import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';

const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 1, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function ThankYou() {
  return (
    <div className="w-full bg-kin-black min-h-[80vh] flex flex-col justify-center">
      <section className="relative px-6 py-20 overflow-hidden text-center">
        <div className="max-w-4xl mx-auto relative z-10">
          <FadeUp>
            <div className="w-16 h-px bg-kin-gold mx-auto mb-12"></div>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-kin-ivory mb-8"> Your Guide Is <span className="italic">On Its Way.</span> </h1>
            <p className="text-lg md:text-xl text-kin-ivory/60 font-light tracking-wide max-w-xl mx-auto leading-relaxed"> Check your inbox for immediate access to <br className="hidden md:block" /> <span className="text-kin-gold italic">The Calling vs Career Clarity Guide.</span> </p>
          </FadeUp>
        </div>
      </section>

      <section className="py-24 px-6 bg-[#09090b] border-y border-kin-ivory/5">
        <div className="max-w-3xl mx-auto text-center">
          <FadeUp>
            <h2 className="text-sm font-sans tracking-[0.4em] uppercase text-kin-gold mb-12"> The Path Forward </h2>
            <h3 className="text-3xl md:text-4xl font-serif text-kin-ivory mb-10"> Your Next Step Starts Here. </h3>
          </FadeUp>
          <div className="space-y-8 text-lg text-kin-ivory/60 font-light leading-relaxed tracking-wide">
            <FadeUp delay={0.1}>
              <p> The guide will help you identify the gap between your calling and your current direction. </p>
            </FadeUp>
            <FadeUp delay={0.2}>
              <p className="text-kin-ivory italic font-serif text-2xl"> But clarity alone is not enough. </p>
            </FadeUp>
            <FadeUp delay={0.3}>
              <p> You also need systems capable of supporting the life you are trying to build. That is exactly why <span className="text-kin-ivory">The Creative Kingdom Blueprint</span> exists. </p>
            </FadeUp>
          </div>
        </div>
      </section>

      <section className="py-32 md:py-48 px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <FadeUp>
            <h4 className="text-2xl md:text-4xl font-serif text-kin-ivory mb-16 leading-tight"> Ready To Build With Alignment,<br className="hidden md:block"/> Stewardship, And Sustainability? </h4>
          </FadeUp>
          <FadeUp delay={0.2}>
            <Link to="/blueprint">
              <Button variant="primary" className="px-16 py-6 text-sm"> Explore The Blueprint </Button>
            </Link>
          </FadeUp>
          <FadeUp delay={0.4} className="mt-12">
            <Link to="/" className="text-xs tracking-[0.3em] uppercase text-kin-ivory/30 hover:text-kin-gold transition-colors duration-500"> Return To Ecosystem </Link>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}